import $ from "jquery";
import { debounce } from "../utils/functions";
import { onTouchEnd, onTouchStart } from "../utils/touch";
var swipeTreshold = { x: 100, y: 50 };
var $window = $(window);
$("[data-milestones-block]").each(function () {
    var _a;
    var $block = $(this);
    /* ------------------------------------------------------ */
    var $list = $block.find("[data-milestones-list]");
    var $buttons = $block.find("[data-milestones-button]");
    var $indicators = $block.find("[data-milestones-indicator]");
    var $items = $block.find("[data-milestones-item]");
    var data = {
        current: 0,
        itemWidth: (_a = $items.get(0)) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width,
        startMousePos: { x: -1, y: -1 },
        endMousePos: { x: -1, y: -1 },
    };
    /* ------------------------------------------------------ */
    var isScrolledLeft = function () { return data.current === 0; };
    var isScrolledRight = function () { return data.current === $items.length - 1; };
    var handleScroll = function () {
        if (isScrolledLeft() && isScrolledRight()) {
            $block.addClass("is-scrolled-left is-scrolled-right");
        }
        else {
            isScrolledLeft()
                ? $block.addClass("is-scrolled-left")
                : $block.removeClass("is-scrolled-left");
            isScrolledRight()
                ? $block.addClass("is-scrolled-right")
                : $block.removeClass("is-scrolled-right");
        }
        $indicators.removeAttr("data-active");
        $indicators
            .filter(function () {
            return $(this).data("index") == data.current;
        })
            .attr("data-active", "true");
        $items.each(function (index) {
            var $thisEl = $(this);
            index < data.current
                ? $thisEl.css("opacity", 0)
                : $thisEl.css("opacity", "");
        });
    };
    /* ------------------------------------------------------ */
    var animate = function () {
        var _a;
        $list.one("transitionend", handleScroll);
        $list.css("transform", "translateX(-" + data.current * ((_a = $items.outerWidth(true)) !== null && _a !== void 0 ? _a : 0) + "px)");
    };
    var scrollLeft = function () {
        if (!isScrolledLeft()) {
            data.current--;
            animate();
        }
    };
    var scrollRight = function () {
        if (!isScrolledRight()) {
            data.current++;
            animate();
        }
    };
    var resizeItems = function () {
        var _a;
        var width = (_a = $block.get(0)) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width;
        if (!width || !data.itemWidth)
            return;
        $items.css("width", width < 1.5 * data.itemWidth ? width : "");
    };
    /* ------------------------------------------------------ */
    $buttons.on("click", function () {
        $(this).data("prev") !== undefined ? scrollLeft() : scrollRight();
    });
    $indicators.on("click", function () {
        data.current = $(this).data("index");
        animate();
    });
    /* ------------------------------------------------------ */
    $window.on("resize:width", debounce(animate));
    $window.on("resize:width", debounce(resizeItems));
    $window.on("touchstart", function (event) {
        onTouchStart(event, data.startMousePos);
    });
    $window.on("touchend", function (event) {
        var mousePosDiff = onTouchEnd(event, data.startMousePos, data.endMousePos)[0];
        if (Math.abs(mousePosDiff.x) > swipeTreshold.x &&
            Math.abs(mousePosDiff.y) <= swipeTreshold.y) {
            mousePosDiff.x < 0 ? scrollLeft() : scrollRight();
        }
    });
    /* ------------------------------------------------------ */
    handleScroll();
    resizeItems();
});
